import axios from 'axios';
import { loginreq, req } from './axiosFun';

// 登录接口 
export const login = (params) => { return loginreq("post", "/fieldmanagesystem/login", params) };



// WEBPACK FOOTER //
// ./src/api/userMG.js